<template>
  <div>
    <div class="p-3 align-middle inline-block min-w-full">
      <div class="!shadow rounded-md overflow-visible border-b border-gray-200">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-100">
            <tr>
              <slot name="columns"></slot>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <slot name="rows"></slot>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
